<template>
  <div class="faq-section">
    <H1>Frequently Asked Questions</H1>
    <el-collapse class="faq-collapse">
      <el-collapse-item
        :title="faqItem.question"
        v-for="(faqItem, i) in faqItems"
        :key="i"
      >
        <div v-html="faqItem.answer"></div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { H1 } from "../../style";
export default {
  name: "Faq",
  components: {
    H1
  },
  data() {
    return {
      faqItems: [
        {
          question: "Who is Dremca?",
          answer:
            "Dremca is an independent insurance agency.  Although our roots date back only a few years, our founders and staff have been in the retail insurance business for 30 years and currently manage $100 million dollars in premium volume."
        },
        {
          question: "Why Dremca?",
          answer:
            "The founders of Dremca are making the insurance buying process easy.  With a few simple key strokes, we are happy to provide you insurance coverage."
        },
        {
          question: "If I do not have a loan, do I need to purchase insurance?",
          answer:
            "There is no legal requirement to purchase this type of insurance.  This type of insurance only covers your investment in the item insured."
        },
        {
          question:
            "I have homeowners’ insurance, does that not cover my item?",
          answer:
            "Depending on what your item is and how it is used, it may.  Please check with your homeowners’ carrier for perils (causes of loss), deductibles and usage (if you use the item in any way to earn money)."
        },
        {
          question: "How do I prove to the lender I have insurance?",
          answer:
            "Please fill out the <a href='/contact' target='_blank'>contact form</a> and we will be happy to provide you with a receipt of coverage for your lender."
        },
        {
          question:
            "What is a loss payee and why is my lender looking to be named that?",
          answer:
            "A loss payee is a third party that has a security interest in your insured item.  If your lender has a loan secured by your property, that security interest is known as collateral.  In the event the loan is not paid, the lender generally has the right to come take that property, sell it and repay the loan.  To protect that interest, the lender generally requires insurance on the item. If the item were damaged and worth less in its damaged state, the lender has the right to require that item be repaired using the insurance proceeds to its pre-damaged state.  If a claim occurs and a check is issued, the check is made payable to you and the lender giving the lender the right to inspect the damaged item to be certain the insurance check was used for repairs and the repairs have been done."
        },
        {
          question: "What is “insurance to value” and why is it important?",
          answer:
            "In the event of a loss, if you did not purchase the appropriate limit of coverage (a number less than what it is truly worth) for your item, the insurance company has the right to pay less than the full value of your claim.  This concept is known as <span class='italic'>co-insurance</span>.  It is important when selecting the limit of coverage to select the correct amount and not something lower.  Please read the policy for specific language, terms and exclusions."
        },
        {
          question:
            "If I have a loss, how much will the insurance company pay me?",
          answer:
            "In the event of a loss, the insurance company will pay at their discretion the amount needed to repair or replace the damaged item.  If the item is less than 7 years old, the valuation will be <span class='italic'>replacement cost</span> meaning the cost to purchase a new item of like, kind and quality.  If the item is 7 years old or greater, the insurance company will pay to purchase an item of like kind, quality and age. This concept is known as <span class='italic'>actual cash value</span> valuation.  In no event will the insurance company pay more than the dollar amount of insurance purchased.  Always refer to the specific policy language."
        },
        {
          question: "If I have a loss, what should I do?",
          answer:
            "In the event of a loss, please call the insurance carrier directly at <a href='tel:800-773-4300'>800 773 4300."
        },
        {
          question: "What should I expect in the event of a loss?",
          answer:
            "In the event of a loss, the insurance carrier will assign an adjuster to your claim.  The adjuster may be an employee of the insurance company or may be an independent third party hired by the insurance company.  The adjuster will want to see the damaged item.  Take photos where possible.  Please refer to the policy language for your rights and responsibilities in the event of a claim."
        },
        {
          question:
            "Does this type of policy cover just damage to my item or does it also cover for damages I may cause to other property or people?",
          answer:
            "The type of policy provided here covers damage only to your property.  The actual name of the policy is an Inland Marine.  Please read the policy for specific language, terms and exclusions."
        },
        {
          question:
            "What types of items are ineligible for insurance through Dremca?",
          answer:
            "Please note insurance available through Dremca does not cover logging equipment, recycling equipment, personal jewelry, or items located outside of our underwriting territory. Binding authority is available for total limits of insurance up to $100,000."
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "~@/style/_variables.scss";
.faq-section {
  background-color: $background-gray;
  padding: 4rem $padding-xxl;
  height: auto;
  margin: $padding-xxl auto 0;
  width: 100%;
  max-width: 800px;
  @media (max-width: $mobile-hd-width) {
    padding: $padding-xxl $padding-lg;
  }
}
</style>
